export default __webpack_public_path__ + "static/media/home.6e6c9d8d.svg";